import { render } from "./CropMecanic.vue?vue&type=template&id=458b36d0&scoped=true&ts=true"
import script from "./CropMecanic.vue?vue&type=script&lang=ts"
export * from "./CropMecanic.vue?vue&type=script&lang=ts"

import "./CropMecanic.vue?vue&type=style&index=0&id=458b36d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458b36d0"]])

export default __exports__